import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Button,
  Box,
  Typography,
  TextField,
  InputAdornment,
  Grid,
  Popover,
  Card,
  TableContainer,
  Paper,
  Chip,
} from "@mui/material";
import {
  AddressBookIcon,
  AddressHomeIcon,
  AddressLocationIcon,
  AddressPhoneIcon,
  AddressThreeDotsIcon,
  PlusIconAdd,
  SearchIcon,
} from "../../../components/Icons";
import { ADDRESS_BOOK } from "../../../api-calls/api-urls";
import classes from "./address.module.css";
import AddAddressPop from "./AddAddressPop";
import DeleteAddressPop from "./deleteAddressPop";
import BulkImportDialog from "./BulkImportDialog";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useEffect, useState } from "react";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import { FaList } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import AddressMaps from "./AddressMaps";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import {
  addCompanyFailure,
  addCompanySuccess,
  deleteCompanyFailure,
  deleteCompanySuccess,
  getAllCompanyAddress,
} from "../../../Redux/actions/address-actions";
import { useNavigate } from "react-router-dom";

function AddressHome() {
  const [isMapScreen, setIsMapScreen] = useState(false);
  const [addressPopup, setAddressPopup] = useState(false);
  const [deleteAddressPopup, setDeleteAddressPopup] = useState(false);
  const [bulkImportOpen, setBulkImportOpen] = useState(false);
  const [activeButton, setActiveButton] = useState("grid");
  const [searchValue, setSearchValue] = useState();
  const [myAllAddress, setMyAllAddress] = useState([]);
  const [singleAddress, setSingleAddress] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputs, setInputs] = useState({
    name: "",
    phone: "",
    address: "",
    maplink: "",
    lat: "",
    lng: "",
  });
  const dispatch = useDispatch();
  const togglesidebar = useSelector(
    (state) => state.allUsers.togglesidebar,
  );
  const ln = useSelector((state) => state.allUsers.language_json);
  const {
    companyAddressList,
    addSuccess,
    addFailure,
    deleteSuccess,
    deleteFailure,
  } = useSelector((state) => state.address);
  let company_infos = JSON.parse(sessionStorage.getItem("userInfo"))?.company;
  const navigate = useNavigate();

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleInputs = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && value?.length > 10) {
      return;
    }
    setInputs({ ...inputs, [name]: value });
  };

  const handleClick = (event, datas) => {
    setAnchorEl(event.currentTarget);
    setSingleAddress(datas);
  };

  const handleClickEdit = () => {
    setInputs({
      name: singleAddress?.customer_name ?? "",
      phone: singleAddress?.mobile_number ?? "",
      address: singleAddress?.address ?? "",
      maplink:
        typeof singleAddress?.location_info?.lat === "string" &&
        singleAddress?.location_info?.lat.startsWith("http")
          ? singleAddress?.location_info?.lat
          : singleAddress?.location_info?.lat &&
              singleAddress?.location_info?.lng
            ? `https://www.google.com/maps?q=${singleAddress?.location_info?.lat},${singleAddress?.location_info?.lng}`
            : "",
      lat: singleAddress?.location_info?.lat ?? "",
      lng: singleAddress?.location_info?.lng ?? "",
    });
    setAnchorEl(null);
    setAddressPopup(true);
  };

  const handlePopperClose = () => {
    setAnchorEl(null);
    setSingleAddress("");
  };

  const handleClose = () => {
    setAddressPopup(false);
    setDeleteAddressPopup(false);
    setInputs({
      name: "",
      phone: "",
      address: "",
      maplink: "",
      lat: "",
      lng: "",
    });
    setSingleAddress("");
  };

  const handleDeleteAddress = async () => {
    try {
      let address_id = singleAddress?._id;
      const { data } = await authApi.delete(`${ADDRESS_BOOK}/${address_id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      dispatch(deleteCompanySuccess(true));
      console.log("answer =", data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddAddress = async () => {
    // Check if the name or map link is empty
    if (inputs.name?.length === 0 || inputs.maplink?.length === 0) {
      return; // Exit the function if validation fails
    }

    try {
      let lat = inputs.lat;
      let lng = inputs.lng;
      if (!lat && inputs.maplink) {
        const match = inputs.maplink.match(/(?:q=|@)(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (match) {
          lat = match[1];
          lng = match[2];
        } else {
          lat = inputs.maplink;
          lng = "";
        }
      }

      // Construct the user entry object
      let userEntry = {
        customer_name: inputs.name,
        address: inputs.address,
        location_info: {
          lat: lat,
          lng: lng,
        },
        mobile_number: inputs.phone,
      };

      // Fetch the company ID
      let company_id = company_infos?._id;

      // Make the API call
      await authApi.post(`${ADDRESS_BOOK}/${company_id}`, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });

      // Dispatch the success action
      dispatch(addCompanySuccess(true));
    } catch (error) {
      console.error("Error adding address:", error);
    }
  };

  const handleUpdateAddress = async () => {
    if (inputs.name?.length === 0 || inputs.maplink?.length === 0) {
    } else {
      let lat = inputs.lat;
      let lng = inputs.lng;
      if (!lat && inputs.maplink) {
        const match = inputs.maplink.match(/(?:q=|@)(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (match) {
          lat = match[1];
          lng = match[2];
        } else {
          lat = inputs.maplink;
          lng = "";
        }
      }

      let userEntry = {
        customer_name: inputs.name,
        address: inputs.address,
        location_info: {
          lat: lat,
          lng: lng,
        },
        mobile_number: inputs.phone,
      };
      let address_id = singleAddress?._id;
      await authApi.put(`${ADDRESS_BOOK}/${address_id}`, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      dispatch(addCompanySuccess(true));
    }
  };

  const handleAddressSearch = () => {
    let my_lists = [...companyAddressList];

    let search_list = my_lists.filter(
      (el) =>
        el.customer_name?.toLowerCase().includes(searchValue) ||
        el.address?.toLowerCase().includes(searchValue) ||
        el.mobile_number?.toLowerCase().includes(searchValue),
    );
    setMyAllAddress(search_list);
  };

  const handleGetAllAddress = async () => {
    try {
      let company_id = company_infos?._id;
      const { data } = await authApi.get(`${ADDRESS_BOOK}/${company_id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });

      dispatch(getAllCompanyAddress(data?.addressBook));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetAllAddress();
  }, []);

  useEffect(() => {
    setMyAllAddress(companyAddressList);
  }, [companyAddressList]);

  useEffect(() => {
    if (searchValue?.length > 2) {
      handleAddressSearch();
    } else {
      setMyAllAddress(companyAddressList);
    }
  }, [searchValue]);

  useEffect(() => {
    if (addSuccess || deleteSuccess) {
      setTimeout(() => {
        dispatch(addCompanySuccess(false));
        dispatch(deleteCompanySuccess(false));
        handleClose();
        handleGetAllAddress();
      }, 2000);
    }
  }, [addSuccess, deleteSuccess]);

  useEffect(() => {
    if (addFailure || deleteFailure) {
      setTimeout(() => {
        dispatch(addCompanyFailure(false));
        dispatch(deleteCompanyFailure(false));
      }, 2000);
    }
  }, [addFailure, deleteFailure]);

  return (
    <>
      {isMapScreen ? (
        <AddressMaps
          setIsMapScreen={setIsMapScreen}
          setInputs={setInputs}
          inputs={inputs}
        />
      ) : (
        <Box>
          <Box display="flex" justifyContent="flex-end" gap={1.5} mb={2}>
            <Button
              variant="outlined"
              startIcon={<UploadFileIcon sx={{ color: "inherit" }} />}
              className={classes.add_address}
              onClick={() => setBulkImportOpen(true)}
            >
              Bulk Upload
            </Button>
            <Button
              variant="contained"
              startIcon={<PlusIconAdd />}
              className={classes.add_address}
              onClick={() => setAddressPopup(true)}
            >
              Add New Customer
            </Button>
          </Box>
          <Box>
            <Card
              sx={{
                p: 3,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #eef2f6",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "24px",
                }}
              >
                <Box display="flex" alignItems="center">
                  <Typography className={classes.viewstyleText}>
                    Customers
                  </Typography>
                  <div className={classes.viewbittonContainer}>
                    <Button
                      className={`${classes.button} ${
                        activeButton === "grid" ? `${classes.active}` : ""
                      }`}
                      onClick={() => setActiveButton("grid")}
                      disableRipple
                    >
                      <BsFillGrid3X3GapFill />
                    </Button>
                    <Button
                      className={`${classes.button} ${
                        activeButton === "list" ? `${classes.active}` : ""
                      }`}
                      onClick={() => setActiveButton("list")}
                      disableRipple
                    >
                      <FaList />
                    </Button>
                  </div>
                </Box>
                <Box>
                  <TextField
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": {
                        border: "1px solid #e0e4ec",
                        borderRadius: "8px",
                      },
                      width: togglesidebar ? "290px" : "360px",
                      background: "#f8fafc",
                    }}
                    placeholder="Search by name, mobile number, area"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    className={classes.teamMemberSearch}
                    id="firstNameinput"
                    value={searchValue}
                    onChange={(e) => {
                      let a = e?.target?.value?.toLowerCase();
                      setSearchValue(a);
                    }}
                    size="small"
                  />
                </Box>
              </Box>

              <Box mt={2}>
                {Array.isArray(myAllAddress) && myAllAddress?.length > 0 ? (
                  activeButton === "list" ? (
                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{
                        border: "1px solid #e8edf2",
                        borderRadius: "12px",
                        overflow: "hidden",
                      }}
                    >
                      <Table>
                        {ln ? (
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#f0f6ff" }}>
                              <TableCell
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "13px",
                                  color: "#0a1f41",
                                  borderBottom: "2px solid #d7edff",
                                  py: 1.5,
                                  px: 2.5,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Customer Name
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "13px",
                                  color: "#0a1f41",
                                  borderBottom: "2px solid #d7edff",
                                  py: 1.5,
                                  px: 2.5,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Mobile Number
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "13px",
                                  color: "#0a1f41",
                                  borderBottom: "2px solid #d7edff",
                                  py: 1.5,
                                  px: 2.5,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Address
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "13px",
                                  color: "#0a1f41",
                                  borderBottom: "2px solid #d7edff",
                                  py: 1.5,
                                  px: 2.5,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Google Map Location
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "13px",
                                  color: "#0a1f41",
                                  borderBottom: "2px solid #d7edff",
                                  py: 1.5,
                                  px: 2.5,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Used
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "13px",
                                  color: "#0a1f41",
                                  borderBottom: "2px solid #d7edff",
                                  py: 1.5,
                                  px: 2.5,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {ln.action}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                        ) : null}
                        <TableBody>
                          {myAllAddress.map((item, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                backgroundColor:
                                  index % 2 === 0 ? "#ffffff" : "#fafbff",
                                "&:hover": { backgroundColor: "#eef5ff" },
                                "&:last-child td": { borderBottom: 0 },
                                transition: "background-color 0.15s ease",
                              }}
                            >
                              <TableCell
                                sx={{ py: 1.75, px: 2.5, whiteSpace: "nowrap" }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    color: "#0a1f41",
                                    fontWeight: 500,
                                  }}
                                >
                                  {item.customer_name}
                                </Typography>
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#6b778c",
                                  fontSize: "13px",
                                  py: 1.75,
                                  px: 2.5,
                                }}
                              >
                                {item.mobile_number
                                  ? item.mobile_number
                                  : "n/a"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#6b778c",
                                  fontSize: "13px",
                                  py: 1.75,
                                  px: 2.5,
                                }}
                              >
                                {item.address ? item.address : "n/a"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#6b778c",
                                  fontSize: "13px",
                                  py: 1.75,
                                  px: 2.5,
                                }}
                              >
                                <a
                                  href={
                                    typeof item.location_info?.lat ===
                                      "string" &&
                                    item.location_info?.lat.startsWith("http")
                                      ? item.location_info?.lat
                                      : `https://www.google.com/maps?q=${item.location_info?.lat},${item.location_info?.lng}`
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#227dc3",
                                    textDecoration: "none",
                                  }}
                                >
                                  {typeof item.location_info?.lat ===
                                    "string" &&
                                  item.location_info?.lat.startsWith("http")
                                    ? item.location_info?.lat
                                    : `https://www.google.com/maps?q=${item.location_info?.lat},${item.location_info?.lng}`}
                                </a>
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#6b778c",
                                  fontSize: "13px",
                                  py: 1.75,
                                  px: 2.5,
                                }}
                              >
                                {item.usage_count > 0 ? (
                                  <Chip
                                    size="small"
                                    clickable
                                    label={item.usage_count}
                                    title={`Used ${item.usage_count} ${
                                      item.usage_count === 1 ? "time" : "times"
                                    } — view history`}
                                    onClick={(e) => {
                                      // The three-dot Popover in the next cell
                                      // anchors off the event target, so this
                                      // click must not bubble.
                                      e.stopPropagation();
                                      navigate(`/address/usage/${item._id}`);
                                    }}
                                  />
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    &mdash;
                                  </Typography>
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#6b778c",
                                  fontSize: "13px",
                                  py: 1.75,
                                  px: 2.5,
                                }}
                              >
                                <Typography
                                  onClick={(e) => handleClick(e, item)}
                                  sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                  }}
                                >
                                  <AddressThreeDotsIcon />
                                </Typography>
                                <Popover
                                  id={id}
                                  open={open}
                                  anchorEl={anchorEl}
                                  onClose={handlePopperClose}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  className="address-popover"
                                >
                                  <Typography
                                    sx={{
                                      p: 2,
                                      pt: 1,
                                      pb: 1,
                                      cursor: "pointer",
                                    }}
                                    onClick={handleClickEdit}
                                  >
                                    Edit
                                  </Typography>
                                  <Typography
                                    sx={{ px: 2, pb: 1, cursor: "pointer" }}
                                    onClick={() => {
                                      setAnchorEl(null);
                                      setDeleteAddressPopup(true);
                                    }}
                                  >
                                    Delete
                                  </Typography>
                                  <Typography
                                    sx={{ px: 2, pb: 1, cursor: "pointer" }}
                                    onClick={() => {
                                      navigate("/location/create-location", {
                                        state: { loc_details: item },
                                      });
                                    }}
                                  >
                                    Assign
                                  </Typography>
                                </Popover>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Grid container spacing={2}>
                      {myAllAddress.map((datas, index) => (
                        <Grid item xs={12} sm={12} md={4} key={index}>
                          <Card
                            elevation={0}
                            sx={{
                              border: "1px solid #e8edf2",
                              borderRadius: "12px",
                              padding: "20px",
                              position: "relative",
                              backgroundColor: "#ffffff",
                              transition:
                                "box-shadow 0.3s ease, border-color 0.3s ease",
                              "&:hover": {
                                boxShadow: "0 8px 24px rgba(10, 31, 65, 0.08)",
                                borderColor: "#d7edff",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                position: "absolute",
                                top: "16px",
                                right: "12px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => handleClick(e, datas)}
                            >
                              <AddressThreeDotsIcon />
                            </Typography>
                            <Box
                              display="flex"
                              alignItems="center"
                              gap="12px"
                              mb={2}
                              pr={3}
                            >
                              <Typography
                                sx={{
                                  fontSize: "15px",
                                  color: "#0a1f41",
                                  fontWeight: 600,
                                }}
                              >
                                {datas.customer_name}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                height: "1px",
                                backgroundColor: "#f0f6ff",
                                mb: 2,
                                mx: "-20px",
                              }}
                            />
                            <Box
                              display="flex"
                              flexDirection="column"
                              gap={1.5}
                            >
                              <Box
                                display="flex"
                                alignItems="flex-start"
                                gap={1.5}
                              >
                                <Box
                                  sx={{
                                    mt: 0.25,
                                    color: "#8a96a8",
                                    display: "flex",
                                  }}
                                >
                                  <AddressPhoneIcon />
                                </Box>
                                <Typography
                                  sx={{ fontSize: "13px", color: "#4a5568" }}
                                >
                                  {datas.mobile_number
                                    ? datas.mobile_number
                                    : "n/a"}
                                </Typography>
                              </Box>
                              <Box
                                display="flex"
                                alignItems="flex-start"
                                gap={1.5}
                              >
                                <Box
                                  sx={{
                                    mt: 0.25,
                                    color: "#8a96a8",
                                    display: "flex",
                                  }}
                                >
                                  <AddressHomeIcon />
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    color: "#4a5568",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }}
                                >
                                  {datas.address ? datas.address : "n/a"}
                                </Typography>
                              </Box>
                              <Box
                                display="flex"
                                alignItems="flex-start"
                                gap={1.5}
                              >
                                <Box
                                  sx={{
                                    mt: 0.25,
                                    color: "#8a96a8",
                                    display: "flex",
                                  }}
                                >
                                  <AddressLocationIcon />
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    color: "#4a5568",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  <a
                                    href={
                                      typeof datas.location_info?.lat ===
                                        "string" &&
                                      datas.location_info?.lat.startsWith(
                                        "http",
                                      )
                                        ? datas.location_info?.lat
                                        : `https://www.google.com/maps?q=${datas.location_info?.lat},${datas.location_info?.lng}`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#227dc3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    View on Map
                                  </a>
                                </Typography>
                              </Box>
                              <Box
                                display="flex"
                                alignItems="flex-start"
                                gap={1.5}
                              >
                                <Box
                                  sx={{
                                    mt: 0.25,
                                    color: "#8a96a8",
                                    display: "flex",
                                  }}
                                >
                                  <AddressBookIcon />
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    color: datas.usage_count
                                      ? "#227dc3"
                                      : "#4a5568",
                                    cursor: datas.usage_count
                                      ? "pointer"
                                      : "default",
                                  }}
                                  onClick={(e) => {
                                    if (!datas.usage_count) return;
                                    e.stopPropagation();
                                    navigate(`/address/usage/${datas._id}`);
                                  }}
                                >
                                  {datas.usage_count
                                    ? `Used ${datas.usage_count} ${
                                        datas.usage_count === 1
                                          ? "time"
                                          : "times"
                                      }`
                                    : "Not used yet"}
                                </Typography>
                              </Box>
                            </Box>
                            <Popover
                              id={id}
                              open={open}
                              anchorEl={anchorEl}
                              onClose={handlePopperClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              className="address-popover"
                            >
                              <Typography
                                sx={{ p: 2, pt: 1, pb: 1, cursor: "pointer" }}
                                onClick={handleClickEdit}
                              >
                                Edit
                              </Typography>
                              <Typography
                                sx={{ px: 2, pb: 1, cursor: "pointer" }}
                                onClick={() => {
                                  setAnchorEl(null);
                                  setDeleteAddressPopup(true);
                                }}
                              >
                                Delete
                              </Typography>
                              <Typography
                                sx={{ px: 2, pb: 1, cursor: "pointer" }}
                                onClick={() => {
                                  navigate("/location/create-location", {
                                    state: { loc_details: datas },
                                  });
                                }}
                              >
                                Assign
                              </Typography>
                            </Popover>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  )
                ) : (
                  <Box className={classes.empty_state_container}>
                    <Box className={classes.empty_icon_wrapper}>
                      <AddressLocationIcon />
                    </Box>
                    <Typography className={classes.empty_title}>
                      {searchValue
                        ? "No matching customers"
                        : "No customers added yet"}
                    </Typography>
                    <Typography className={classes.empty_subtitle}>
                      {searchValue
                        ? `We couldn't find any customers matching "${searchValue}". Try a different keyword.`
                        : "Add customers one at a time, or upload an Excel sheet to add many at once."}
                    </Typography>
                    {!searchValue && (
                      <Box display="flex" gap={1.5} justifyContent="center">
                        <Button
                          variant="outlined"
                          startIcon={<UploadFileIcon sx={{ color: "inherit" }} />}
                          onClick={() => setBulkImportOpen(true)}
                          className={classes.add_address_empty}
                        >
                          Bulk Upload
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<PlusIconAdd />}
                          onClick={() => setAddressPopup(true)}
                          className={classes.add_address_empty}
                        >
                          Add Your First Customer
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </Card>
          </Box>

          <AddAddressPop
            open={addressPopup}
            handleClose={handleClose}
            inputs={inputs}
            setInputs={setInputs}
            handleInputs={handleInputs}
            setIsMapScreen={setIsMapScreen}
            handleAddAddress={handleAddAddress}
            singleAddress={singleAddress}
            handleUpdateAddress={handleUpdateAddress}
          />
          <DeleteAddressPop
            open={deleteAddressPopup}
            handleClose={handleClose}
            handleDeleteAddress={handleDeleteAddress}
          />
          <BulkImportDialog
            open={bulkImportOpen}
            companyId={company_infos?._id}
            onClose={(createdCount) => {
              setBulkImportOpen(false);
              if (createdCount > 0) handleGetAllAddress();
            }}
          />
        </Box>
      )}
    </>
  );
}

export default AddressHome;
